@switch (true) {
  @case (initializationInProgress && !mission?.endDate) {
    <div class="company-status-container" tiimeTooltip="Dossier en cours de paramétrage par Tiime">
      @if (withIcon) {
        <mat-icon svgIcon="icon-tune" />
      }
      @if (withLabel) {
        <span class="company-status-label">En cours de paramétrage</span>
      }
    </div>
  }
  @case (mission?.worksStop && !mission?.endDate) {
    <div class="company-status-container warn" tiimeTooltip [tooltipContent]="endOfMissionTooltipTemplate">
      @if (withIcon) {
        <mat-icon svgIcon="icon-do-not-disturb" />
      }
      @if (withLabel) {
        <span class="company-status-label">
          Arrêt des travaux : {{ mission?.worksStopUpdatedAt | date: 'shortDate' }}
        </span>
      }
    </div>
  }
  @case (mission?.endDate && mission?.exitMotif !== MissionExitMotifCodeEnum.activityTermination) {
    <div class="company-status-container warn" tiimeTooltip [tooltipContent]="endOfMissionTooltipTemplate">
      @if (withIcon) {
        <mat-icon svgIcon="icon-file-cross" />
      }
      @if (withLabel) {
        <span class="company-status-label">Fin de mission : {{ mission?.endDate | date: 'shortDate' }}</span>
      }
    </div>
  }
  @case (mission?.endDate && mission?.exitMotif === MissionExitMotifCodeEnum.activityTermination) {
    <div class="company-status-container warn" tiimeTooltip [tooltipContent]="endOfMissionTooltipTemplate">
      @if (withIcon) {
        <mat-icon svgIcon="icon-file-info" />
      }
      @if (withLabel) {
        <span class="company-status-label">Fin de mission : {{ mission?.endDate | date: 'shortDate' }}</span>
      }
    </div>
  }
}

<ng-template #endOfMissionTooltipTemplate>
  <div class="company-end-of-mission-details-container">
    @if (mission?.worksStop) {
      <div class="company-end-of-mission-details-row">
        <span class="company-end-of-mission-details-row-label">Date d'arrêt des travaux:</span>
        <span class="company-end-of-mission-details-row-value">
          {{ mission?.worksStopUpdatedAt | date: 'shortDate' }}
        </span>
      </div>
    }
    @if (mission?.endDate) {
      <div class="company-end-of-mission-details-row">
        <span class="company-end-of-mission-details-row-label">Date de fin de mission:</span>
        <span class="company-end-of-mission-details-row-value">{{ mission?.endDate | date: 'shortDate' }}</span>
      </div>
    }
    @if (mission?.endDate && mission?.lastBilanDueDate) {
      <div class="company-end-of-mission-details-row">
        <span class="company-end-of-mission-details-row-label">Dernière échance bilan:</span>
        <span class="company-end-of-mission-details-row-value">
          {{ mission?.lastBilanDueDate | date: 'shortDate' }}
        </span>
      </div>
    }
    @if (mission?.endDate && mission?.lastVatDueDate) {
      <div class="company-end-of-mission-details-row">
        <span class="company-end-of-mission-details-row-label">Dernière échance fiscale TVA:</span>
        <span class="company-end-of-mission-details-row-value">
          {{ mission?.lastVatDueDate | date: 'shortDate' }}
        </span>
      </div>
    }
    @if (mission?.endDate && mission?.exitMotif) {
      <div class="company-end-of-mission-details-row">
        <span class="company-end-of-mission-details-row-label">Motif:</span>
        <span class="company-end-of-mission-details-row-value">
          {{ mission?.exitMotif | missionMotifLabel: (missionMotifs$ | async) }}
        </span>
      </div>
    }
  </div>
</ng-template>
